import { render, staticRenderFns } from "./DfCorrectionHistoryModal.vue?vue&type=template&id=29f024cc"
import script from "./DfCorrectionHistoryModal.vue?vue&type=script&lang=js"
export * from "./DfCorrectionHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports